import * as React from "react";
import BaseDialog from "../modelDialogs/BaseDialog";

export default function WaitDialog(props: { title: string; text: string }): JSX.Element {
  const { title, text } = props;

  return (
    <BaseDialog title={title} noAbortButton={true} noOkButton={true} hideXButton={true}>
      <div style={{ padding: "20px" }}>
        <div style={{ fontSize: "20px", display: "flex", justifyContent: "center" }}>
          <i
            className={"las la-spinner la-spin"} // no itx
          ></i>
        </div>

        <br />
        {text}
        <br />
      </div>
    </BaseDialog>
  );
}
